import Send from '@/assets/icons/Send';
import { Box } from '@/shared/ui/layout/Box';
import Button from '@/shared/ui/primitives/Button';
import TextField from '@/shared/ui/primitives/TextField';

import { useMessageInput } from './useMessageInput';

const MessageInput = ({ maxRows }: { maxRows: number }) => {
  const { inputMessage, isDisabled, handleSend, handleChange, handleKeyDown } = useMessageInput();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderTop: '1px solid',
        borderTopColor: 'gx.textDisabled'
      }}
    >
      <TextField
        fullWidth
        multiline
        maxRows={maxRows}
        placeholder='Enter your prompt...'
        sx={{
          minWidth: 0,
          height: '100%',
          padding: '16px',
          '& .MuiInputBase-input::placeholder': {
            color: 'common.white',
            opacity: 1
          },
          '& .MuiInputBase-root': {
            p: 0,
            height: '100%',
            display: 'block'
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: 'none'
            },
            '&.Mui-focused fieldset': {
              border: 'none'
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: 'none'
            }
          }
        }}
        value={inputMessage}
        onChange={e => {
          handleChange(e.target.value);
        }}
        onKeyDown={handleKeyDown}
      />
      <Button
        color='primary'
        disabled={isDisabled || !inputMessage.trim()}
        sx={{
          width: '48px',
          minWidth: '48px',
          height: '108px',
          p: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          '&.Mui-disabled': {
            backgroundColor: 'gx.actionBarButtonTile',
            color: 'gx.text',
            opacity: 1
          }
        }}
        variant='contained'
        onClick={handleSend}
      >
        <Send sx={{ fontSize: '24px !important', m: '0 !important' }} />
      </Button>
    </Box>
  );
};

export default MessageInput;
